export const getMappedDolyame = (dolyame) => {
  return dolyame?.length > 0 ? dolyame[0] : false
}
